module.exports = __webpack_public_path__ + "img/23.041a773d.jpg";